import ChooseAFolderInDr from './ChooseAFolderInDr.component';

export default ChooseAFolderInDr;